"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const mf_contracts_4services_1 = require("@4r/mf-contracts-4services");
const mf_app_1 = require("@4r/mf-app");
function useOfflineFetch(key, service, loadMethod, loadMethodDeps) {
    const [data, setData] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const storageService = (0, mf_app_1.getService)(mf_contracts_4services_1.ServiceNames.Storage);
    const fetchAsync = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const record = yield loadMethod(key, service, storageService);
            setData(record);
            return record;
        }
        finally {
            setIsLoading(false);
        }
    }), [key, service, storageService, ...(loadMethodDeps !== null && loadMethodDeps !== void 0 ? loadMethodDeps : [])]); // the loadMethod will be chaning with each rerender
    (0, react_1.useEffect)(() => {
        fetchAsync();
        // observe strage changes for the key
        const unsubscribe = storageService.subscribe((_, v) => setData(v), key);
        return unsubscribe;
    }, [key, storageService, fetchAsync]);
    return [data, isLoading, fetchAsync];
}
exports.default = useOfflineFetch;
